import React, { useEffect, useState, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Signuptogetstarted from "../Signuptogetstarted";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useNavigate } from "react-router-dom";
import {
  checkMobile,
  sendOTP,
} from "../../../../redux/zservices/BasicAPIFunctions";
import PhoneInput from "react-phone-input-2";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import VerifyOTP from "../VerifyOTP/VerifyOTP";
import "react-phone-input-2/lib/style.css";
import { handleKeyDown } from "../../../Common/FewCommonMethods";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import { detectCountryFromIP } from "../../../../utils/detectCountryFromIP";
import { mobilenumbervalidation } from "../../../Common/commonvalidation";
import messageicon from "../../../../assests/imgs/annotation-dots.svg";
import whatsappicon from "../../../../assests/imgs/message-text-circle-02.svg";

const path = "Assets/scss/FirstTimeUsers.module.scss";

const validationSchema = Yup.object().shape({
  country_code: Yup.string().required("Country code is required"),
  mobile_number: mobilenumbervalidation,
});

export default function LoginwithMobile() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [nextPage, setNextPage] = useState(true);
  const [valuess, setValuess] = useState(null);

  // Added a ref to track which button was clicked without causing re-renders
  const isWhatsappRef = useRef(0);

  const navigate = useNavigate();
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [selectCountryCode, setSelectCountryCode] = useState("");

  useEffect(() => {
    detectCountryFromIP().then((res) => {
      setSelectCountryCode(res.dial_code || "+91");
    });
  }, []);

  const initialValues = {
    country_code: valuess?.country_code || selectCountryCode || "+966",
    mobile_number: "",
  };

  const handleSubmit = (values) => {
    // Construct a new payload to append the flag if required
    const payload = { ...values };
    if (isWhatsappRef.current === 1) {
      payload.is_whatsapp = 1;
    }

    checkMobile(payload)
      .then((res) => {
        if (res.data.status) {
          sendOTP(payload)
            .then((res) => {
              if (res.data.status) {
                urtoast(`OTP sent successfully.`, 1);
                setNextPage(false);
                setValuess(payload); // Storing the payload to pass along the flag if needed later
              } else {
                urtoast(`${res?.data?.response?.message}`, 2);
              }
            })
            .catch((e) => {
              urtoast(`${e.message} || "Error sending OTP"`, 2);
            });
        } else {
          urtoast(`${res.data.response.message}.`, 2);
        }
      })
      .catch((e) => {
        urtoast(`${e.message}.`, 2);
      })
      .finally(() => {});
  };

  const modifyCountyCodeValue = (
    setFieldValue,
    countryCode,
    mobileWithCounty
  ) => {
    setFieldValue("country_code", `+${countryCode}`);
  };

  return (
    <>
      {nextPage ? (
        <div className="mx-auto register">
          <h1 className="heading">Login account</h1>
          <Signuptogetstarted />

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ errors, values, touched, setFieldValue }) => (
              <Form>
                <div className="col-md-8 mx-auto form-sec mobile-otp">
                  <div className="row">
                    <div className="form-group col-md-4 col-5">
                      <label htmlFor="country_code">
                        Country Code <AsteriskLabel />
                      </label>
                      <PhoneInput
                        country={"sa"}
                        value={values.country_code}
                        onChange={(value, country) => {
                          modifyCountyCodeValue(
                            setFieldValue,
                            country.dialCode,
                            value
                          );
                        }}
                        inputProps={{
                          name: "mobile_number",
                          id: "mobile_number",
                          className: "form-control",
                          readOnly: true,
                        }}
                        specialLabel=""
                        buttonStyle={{
                          borderRadius: "0",
                          border: "1px solid #ced4da",
                        }}
                        containerStyle={{ marginBottom: "10px" }}
                      />
                      <ErrorMessage
                        name="country_code"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="form-group col-md-8 col-7 pl-0">
                      <label htmlFor="mobile_number">
                        Mobile Number <AsteriskLabel />
                      </label>
                      <Field
                        type="text"
                        name="mobile_number"
                        className={`form-control ${
                          errors.mobile_number && touched.mobile_number
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter mobile number"
                        onKeyDown={handleKeyDown}
                      />
                      <ErrorMessage
                        name="mobile_number"
                        component="div"
                        className="error"
                      />
                    </div>
                  </div>
                  <div className="last-form">
                    <div className="d-flex">
                      {/* Set the ref to 0 for SMS */}
                      <button
                        type="submit"
                        className="btn create-account mr-1"
                        style={{ columnGap: "10px" }}
                        onClick={() => {
                          isWhatsappRef.current = 0;
                        }}
                      >
                        <img src={messageicon} alt="" /> Verify via SMS
                      </button>
                      
                      {/* Set the ref to 1 for WhatsApp */}
                      <button
                        type="submit"
                        className="btn create-account"
                        style={{ columnGap: "10px", background: "#1DAA61" }}
                        onClick={() => {
                          isWhatsappRef.current = 1;
                        }}
                      >
                        <img src={whatsappicon} alt="" /> Verify via WhatsApp
                      </button>
                    </div>
                    <a
                      onClick={() => navigate(`/${lan}/loginwithemail`)}
                      className="login-password"
                    >
                      Login with Email
                    </a>
                    <p>
                      Don’t have an account?
                      <a onClick={() => navigate(`/${lan}/signup`)}> Sign up</a>
                    </p>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      ) : (
        <VerifyOTP setnextPage={setNextPage} valuess={valuess} />
      )}
    </>
  );
}